/* eslint-disable no-empty-pattern */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import apiIntegracaoOito from '@services/apiIntegracaoOito';


async function fetchTokenImobiliaria(partner: any, bearer: string): Promise<any> {
    const empresaId = process.env.NEXT_PUBLIC_TOKEN_PARCEIRO_OITO|| '63A3B459-2876-46E2-BBFA-0AB3D56DA071';
    const headers = {
        'Authorization': `Bearer  ${bearer}`
    }
    const filter = {
        tokenParceiro: empresaId,
        cnpjImobiliaria: partner

    }

    const responseData = await apiIntegracaoOito
        .get(`integracaoParceiro/ObterImobiliariasParceiro`, {
            params: filter,
            headers: headers
        })
        .then((res: any) => {
            return res.data || [];
        });

    return responseData
}

export default fetchTokenImobiliaria;
